<template>
  <ul
    id="boss-tab-menu"
    class="tabs boss-tabs-menu-list"
    data-tabs
  >
    <scout-tab-recommendation
      v-if="!hasEndedContract(contractId)"
    />
    <scout-tab-search-condition
      v-if="!hasEndedContract(contractId)"
      :job-id="jobId"
    />
    <scout-tab-under-review />
    <scout-tab-liked />
    <scout-tab-scouted />
    <scout-tab-reservation />
  </ul>
</template>

<script>
import ScoutTabLiked from '@/components/molecules/ScoutTabLiked'
import ScoutTabRecommendation from '@/components/molecules/ScoutTabRecommendation'
import ScoutTabScouted from '@/components/molecules/ScoutTabScouted'
import ScoutTabSearchCondition from '@/components/molecules/ScoutTabSearchCondition'
import ScoutTabUnderReview from '@/components/molecules/ScoutTabUnderReview'
import ScoutTabReservation from '@/components/molecules/ScoutTabReservation'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutTabLiked,
    ScoutTabRecommendation,
    ScoutTabScouted,
    ScoutTabSearchCondition,
    ScoutTabUnderReview,
    ScoutTabReservation
  },
  props: {
    jobId: {
      type: Number,
      default: null
    },
    contractId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'hasEndedContract'
    ])
  }
}
</script>
